import { Box } from "@material-ui/core";
import flyByWptImg from "../../../images/contents/map/fix/Fly-by_WPT.png";
import triangle01Img from "../../../images/contents/map/fix/triangle_01.png";
import triangle02Img from "../../../images/contents/map/fix/triangle_02.png";
import { LegendBoxList, LegendBoxListItem, LegendBoxListItemText } from "../../legend/LegendBoxComponents";
import { memo } from "react";

function LegendFix() {

  return (
    <Box sx={{minWidth: 235}}>
      <LegendBoxList>
        <LegendBoxListItem>
          <img src={triangle01Img} alt="Compulsory Reporting Point"/><LegendBoxListItemText>Compulsory Reporting Point</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img src={triangle02Img} alt="Non-Compulsory Reporting"/><LegendBoxListItemText>Non-Compulsory Reporting</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img src={flyByWptImg} alt="RNAV Waypoint"/><LegendBoxListItemText>RNAV Waypoint</LegendBoxListItemText>
        </LegendBoxListItem>
      </LegendBoxList>
    </Box>
  )
}

export default memo(LegendFix);